import React, { useState, useEffect } from 'react';
import SunCalc from 'suncalc'; // Ensure SunCalc is installed: npm install suncalc

function VintageTime({ locale = 'fr-FR' }) {
  const [currentDate, setCurrentDate] = useState(new Date());
  const [location, setLocation] = useState('St. Tropez');

  const locationsData = {
    'St. Tropez': { timeZone: 'Europe/Paris', lat: 43.2734, lng: 6.6408 },
    'Milan': { timeZone: 'Europe/Rome', lat: 45.4642, lng: 9.1900 },
    'Katmandou': { timeZone: 'Asia/Kathmandu', lat: 27.7172, lng: 85.3240 },
    'Saïgon': { timeZone: 'Asia/Ho_Chi_Minh', lat: 10.8231, lng: 106.6297 },
    'Tokyo': { timeZone: 'Asia/Tokyo', lat: 35.6895, lng: 139.6917 },
    'Los Angeles': { timeZone: 'America/Los_Angeles', lat: 34.0522, lng: -118.2437 },
    'New York': { timeZone: 'America/New_York', lat: 40.7128, lng: -74.0060 },
    'Londres': { timeZone: 'Europe/London', lat: 51.5074, lng: -0.1278 },
  };

  const locations = Object.keys(locationsData);

  useEffect(() => {
    const timer = setInterval(() => {
      setCurrentDate(new Date());
    }, 1000);

    return () => clearInterval(timer);
  }, []);

  const toggleLocation = () => {
    setLocation((prevLocation) => {
      const currentIndex = locations.indexOf(prevLocation);
      const nextIndex = (currentIndex + 1) % locations.length;
      return locations[nextIndex];
    });
  };

  const { timeZone, lat, lng } = locationsData[location];

  // Get date components in the target time zone
  const dateFormatter = new Intl.DateTimeFormat('en-CA', {
    timeZone,
    year: 'numeric',
    month: '2-digit',
    day: '2-digit',
  });
  const dateString = dateFormatter.format(currentDate); // e.g., '2023-09-26'
  const [yearStr, monthStr, dayStr] = dateString.split('-');
  const year = parseInt(yearStr, 10);
  const month = parseInt(monthStr, 10); // months are 1-indexed here
  const day = parseInt(dayStr, 10);

  // Function to determine if a year is a leap year
  const isLeapYear = (year) => {
    return new Date(year, 1, 29).getDate() === 29;
  };

  // Function to calculate the day of the year
  const dayOfYear = (year, month, day) => {
    const monthDays = [31, isLeapYear(year) ? 29 : 28, 31, 30, 31, 30,
                       31, 31, 30, 31, 30, 31];
    let dayCount = 0;
    for (let i = 0; i < month - 1; i++) {
      dayCount += monthDays[i];
    }
    return dayCount + day;
  };

  // Calculate days elapsed and remaining in the year
  const daysElapsed = dayOfYear(year, month, day);
  const totalDays = isLeapYear(year) ? 366 : 365;
  const daysRemaining = totalDays - daysElapsed;

  // Format date components for display
  const dayOfWeek = currentDate.toLocaleDateString(locale, {
    weekday: 'long',
    timeZone,
  }).toLowerCase();

  const monthName = currentDate.toLocaleDateString(locale, {
    month: 'long',
    timeZone,
  }).toUpperCase();

  const date = currentDate.toLocaleDateString(locale, {
    day: 'numeric',
    timeZone,
  });

  const formattedYear = currentDate.toLocaleDateString(locale, {
    year: 'numeric',
    timeZone,
  });

  // Function to calculate daylight hours in local timezone
  const calculateDaylightHours = (date, lat, lng, timeZone) => {
    const times = SunCalc.getTimes(date, lat, lng);
    const sunrise = times.sunrise;
    const sunset = times.sunset;

    // Handle cases where sunrise or sunset might be undefined (e.g., polar regions)
    if (!sunrise || !sunset) {
      return 'N/A';
    }

    // Format sunrise and sunset times
    const formattedSunrise = sunrise.toLocaleTimeString(locale, {
      hour: 'numeric',
      minute: '2-digit',
      hour12: false,
      timeZone,
    }).replace(':', '\u2009h.\u2009');

    const formattedSunset = sunset.toLocaleTimeString(locale, {
      hour: 'numeric',
      minute: '2-digit',
      hour12: false,
      timeZone,
    }).replace(':', '\u2009h.\u2009');

    return `${formattedSunrise} - ${formattedSunset}`;
  };

  // Calculate daylight hours in local timezone
  const daylightHours = calculateDaylightHours(currentDate, lat, lng, timeZone);

  return (
    <div className="vintage-container">
      <div className="year">{formattedYear}</div>
      <div className="line"></div>
      <div className="day">{dayOfWeek}</div>
      <div className="date">{date}</div>
      <div className="month">{monthName}</div>
      <div className="location" onClick={toggleLocation}>
        {location === 'St. Tropez' ? (
          <>
            S<span className="half-t">T</span> TROPEZ
          </>
        ) : (
          location.toUpperCase()
        )}
      </div>
      <div className="placeholders">
        <span className="placeholder-left">{daysElapsed}</span>
        <span className="placeholder-right">{daysRemaining}</span>
      </div>
      <div className="row time">{daylightHours}</div>
    </div>
  );
}

export default VintageTime;
